/**
 * @module components\ghModelView\propView\templates\numberInput
 */
import Vue from "vue";
import Component from "vue-class-component";
import Base from "./../../base";

@Component
export default class NumberInput extends Base {}
